import { Component, OnInit, Input } from "@angular/core"
import { Observable, Subscription } from "rxjs"
import { Store, select } from "@ngrx/store"
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from "@angular/router"
import { HelpersService } from "src/app/services/helpers.service"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-navbar-bottom",
	templateUrl: "./navbar-bottom.component.html",
	styleUrls: ["./navbar-bottom.component.scss"]
})
export class NavbarBottomComponent implements OnInit {
	public showRight: boolean
	public currentUrl = ""
	public loading = false
	public activeTab = false
	public assets_version = environment.ASSETS_VERSION

	@Input() disableRipple: boolean

	constructor(
		private router: Router,
		public helpersService: HelpersService
	) {
		this.router.events.subscribe((event: Event) => {
			switch (true) {
				case event instanceof NavigationStart: {
					this.loading = true
					break
				}
				case event instanceof NavigationEnd:
				case event instanceof NavigationCancel:
				case event instanceof NavigationError: {
					this.loading = false
					break
				}
			}
		})
	}

	ngOnInit() {
		this.takeCurrentUrl()
	}

	public takeCurrentUrl() {
		this.currentUrl = this.router.url
	}

	public toggleView() {}

	public hideMap() {
		this.showRight = true
	}
}
